<!--    
@description 表单弹出框
@author zhijie.huang
@date 2018/9/27
@version v1.1.0

/**** mixin ****/
dialog from './mixins/dialog'

/**** props ****/
// 表单元素配置
inputData: [
  {
    label: String,
    key: String,
    type: (原生input type: text（默认）/ textarea / select / selectBox),
    hidden: true/false,
    diable: true/false,
    select: {

    },
    selectBox: {

    }
  }
],
// 数据
model: '',
// 校验规则
rules: {},
// 取消回调
cancelFun: Function,
// 确认回调
confirmFun: Function,
// 取消文案
cancelLabel: String,
// 确认文案
confirmLabel: String
-->
<template>
  <el-dialog :closeOnClickModal="false"
    :title="title"
    :visible.sync="iVisible"
    :width="iWidth">
    <el-form :ref="id+'form'" 
      :label-width="iLabelWidth" 
      :model="model" 
      :rules="rules">
      <el-form-item v-for="(item) in inputData" v-show="!item.hidden"
        :key="item.key" 
        :label="item.label" 
        :prop="item.key"
        :input-width="item.inputWidth ? item.inputWidth : 'auto'">
        <el-select v-if="item.type == 'select'" v-model="model[item.key]" :disabled="item.disabled ? item.disabled : false" >
          <el-option
            v-for="(sitem, skey) in item.select"
            :key="skey"
            :label="sitem"
            :value="skey">
          </el-option>
        </el-select>
        <el-checkbox-group 
          v-else-if="item.type == 'checkboxGroup'"
          v-model="model[item.key]">
          <el-checkbox v-for="(sitem, skey) in item.select" :label="sitem" :key="skey"></el-checkbox>
        </el-checkbox-group>
        <el-radio-group 
          v-else-if="item.type == 'radio'"
          v-model="model[item.key]">
          <el-radio :label="skey" v-for="(sitem, skey) in item.select" :key="skey">{{sitem}}</el-radio>
        </el-radio-group>
        <el-transfer v-else-if="item.type == 'selectBox'" v-model="model[item.key]" :data="item.selectBox" @change="item.selectBoxChange"></el-transfer>
        <el-input v-else v-model="model[item.key]"
          :disabled="item.disabled ? item.disabled : false" 
          :type="item.type ? item.type : 'text'"
          :placeholder="item.placeholder ? item.placeholder : ''"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="e_cancel">{{ cancelLabel }}</el-button>
      <el-button type="primary" @click="e_confirm">{{ confirmLabel }}</el-button>
      <el-button type="primary" v-show="isExtra" @click="e_extraFun">{{ extraLabel }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import dialog from '@/components/mixins/dialog'
export default {
  mixins: [dialog],
  data () {
    return {}
  },
  watch: {
    model: {
      deep: true,
      handler: function (val) {
      }
    },
    iVisible (val) {
      if (!val) return
      this.$nextTick(() => {
        this.$refs[`${this.id}form`].clearValidate()
      })
    }
  },
  computed: {
  },
  props: {
    id: {
      type: String
    },
    inputData: {
      type: Array,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    rules: {
      type: Object
    },
    cancelFun: {
      type: Function,
      default: null
    },
    confirmFun: {
      type: Function,
      default: null
    },
    cancelLabel: {
      type: String,
      default () {
        return this.$t('common.cancel')
      }
    },
    confirmLabel: {
      type: String,
      default () {
        return this.$t('common.confirm')
      }
    },
    isExtra: {
      type: Boolean,
      default: false
    },
    extraFun: {
      type: Function,
      default: null
    },
    extraLabel: {
      type: String,
      default: null
    }
  },
  methods: {
    e_cancel () {
      const formName = `${this.id}form`
      this.iVisible = false
      this.$refs[formName].resetFields()
      this.cancelFun && this.cancelFun()
    },
    e_confirm () {
      const formName = `${this.id}form`
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmFun && this.confirmFun(this.model)
          this.$nextTick(() => {
            this.$refs[formName].resetFields()
          })
        } else {
          return false
        }
      })
    },
    e_extraFun () {
      const formName = `${this.id}form`
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.extraFun && this.extraFun(this.model)
        } else {
          return false
        }
      })
    }
  }
}
</script>
